import { render, staticRenderFns } from "./Digivihot.vue?vue&type=template&id=7bd1bda4&scoped=true"
import script from "./Digivihot.vue?vue&type=script&lang=js"
export * from "./Digivihot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1bda4",
  null
  
)

export default component.exports